import defaultStore from "@/store";

export const getCurrentText = (
  itemIdx: number,
  variantIdx: string | string[],
  unique: boolean = false
): string => {
  const currentStore = defaultStore;

  if (typeof variantIdx === "string") {
      variantIdx = [variantIdx]
  } else {
      variantIdx = variantIdx as string[];
  }

  if (itemIdx < 0) {
    const variantTexts: string[] = [];

    for (let i = 0; i < currentStore.getters["session/getNumberOfItems"]; i++) {
        const variantIdxText: string[] = []
        for (const finalVariantIdx of variantIdx) {
            variantIdxText.push(getFinalText(i, finalVariantIdx, currentStore, unique))
        }

        const text = variantIdxText.join(', ');
        if (!variantTexts.includes(text)) {
            variantTexts.push(text);
        }
    }

    return variantTexts.join(' | ');
  } else {
      const variantIdxText: string[] = []
      for (const finalVariantIdx of variantIdx) {
          variantIdxText.push(getFinalText(itemIdx, finalVariantIdx, currentStore, unique))
      }

      return variantIdxText.join(', ');
  }
};

const getFinalText = (itemIdx: number, variantIdx: string, store: any, unique: boolean = false) => {
  const variants = store.getters["session/getVariant"](itemIdx, variantIdx);
  if (!variants) return '';

  const texts: string[] = variants.map((variant: any) => variant.text).filter(Boolean);
  return (unique ? Array.from(new Set(texts)) : texts).join(', ');
}

export default {
  getCurrentText,
};
